var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuickView = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  fillRule: "evenodd",
  d: "M16 10a.5.5 0 0 1-.076.266C14.3 12.848 12.474 14 10 14c-2.473 0-4.3-1.152-5.923-3.734a.5.5 0 0 1 0-.532C5.7 7.152 7.527 6 10 6s4.3 1.152 5.924 3.734A.5.5 0 0 1 16 10m-7.389 2.079A2.5 2.5 0 1 0 11.39 7.92a2.5 2.5 0 0 0-2.778 4.158M11.5 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  d: "M2.667 5.333a.667.667 0 0 0 .666-.666V3.333h1.334a.667.667 0 1 0 0-1.333h-2A.667.667 0 0 0 2 2.667v2a.667.667 0 0 0 .667.666M17.33 2h-2a.667.667 0 1 0 0 1.333h1.334v1.334a.667.667 0 1 0 1.333 0v-2A.666.666 0 0 0 17.331 2M4.667 16.668H3.333v-1.333a.667.667 0 0 0-1.333 0v2a.667.667 0 0 0 .667.666h2a.666.666 0 1 0 0-1.333M17.33 14.668a.667.667 0 0 0-.666.667v1.333h-1.333a.667.667 0 1 0 0 1.333h2a.666.666 0 0 0 .666-.666v-2a.667.667 0 0 0-.666-.667"
})));
export default SvgQuickView;